import Tile from "../Tile";
import MUIGreyColor from "@mui/material/colors/grey";
import HcpcsCode from "../../Utility/Crud/HcpcsCode";
import PropTypes from "prop-types";
import MainContext from "../../Context/MainContext/MainContext";

export default class TileHcpcsCode extends Tile {
  static contextType = MainContext; // For legacy class components

  /**
   * @returns {string} The InsuranceType name.
   */
  getTitle() {
    return this.props.hcpcsCode
      ? HcpcsCode.getDisplayName(this.props.hcpcsCode)
      : "None";
  }

  /**
   * @returns {string} The string to be used by the avatar abbreviation
   * formatter.
   */
  getAvatarString() {
    return this.props.hcpcsCode
      ? HcpcsCode.getDisplayName(this.props.hcpcsCode)
      : null;
  }

  /**
   * @returns {string} The color of the avatar.
   */
  getAvatarColor() {
    return this.props.hcpcsCode ? HcpcsCode.getColor() : MUIGreyColor[400];
  }

  /**
   * Renders an icon to represent the avatar if no string is provided.
   */
  renderAvatarIcon() {
    return HcpcsCode.getIcon();
  }
}
